import { ROUTES, currentView, navigate, onRouteChange } from '../router';
import type { ViewId } from '../router';

export function renderShell(root: HTMLElement, onView: (view: ViewId, container: HTMLElement) => void): void {
  root.innerHTML = `
    <aside class="w-60 shrink-0 border-r border-slate-200 bg-white flex flex-col">
      <div class="px-5 py-4 border-b border-slate-200">
        <h1 class="text-lg font-semibold text-slate-900">Pulse Explorer</h1>
        <p class="text-xs text-slate-500 mt-0.5">Catálogo & análisis</p>
      </div>
      <nav id="nav" class="flex-1 overflow-y-auto p-3 space-y-4"></nav>
      <div class="px-4 py-3 border-t border-slate-200 text-[11px] text-slate-400" id="footer">
        cargando…
      </div>
    </aside>
    <main class="flex-1 overflow-hidden flex flex-col">
      <header class="border-b border-slate-200 bg-white px-6 py-3 flex items-center justify-between">
        <div>
          <h2 id="view-title" class="text-base font-semibold text-slate-900"></h2>
          <p id="view-subtitle" class="text-xs text-slate-500 mt-0.5"></p>
        </div>
        <div class="text-xs text-slate-400" id="data-stamp"></div>
      </header>
      <div id="view-container" class="flex-1 overflow-auto bg-slate-50"></div>
    </main>
  `;

  const navEl = root.querySelector('#nav') as HTMLElement;
  const grouped = new Map<string, typeof ROUTES>();
  for (const r of ROUTES) {
    const g = r.group || '';
    if (!grouped.has(g)) grouped.set(g, []);
    grouped.get(g)!.push(r);
  }

  for (const [group, items] of grouped) {
    const sec = document.createElement('div');
    sec.innerHTML = `<div class="text-[10px] font-semibold uppercase tracking-wider text-slate-400 px-3 mb-1">${group}</div>`;
    for (const r of items) {
      const btn = document.createElement('div');
      btn.className = 'nav-item';
      btn.dataset.view = r.id;
      btn.innerHTML = `<span class="text-base">${r.icon}</span><span>${r.label}</span>`;
      btn.addEventListener('click', () => navigate(r.id));
      sec.appendChild(btn);
    }
    navEl.appendChild(sec);
  }

  const setActive = (view: ViewId) => {
    navEl.querySelectorAll('.nav-item').forEach((el) => {
      el.classList.toggle('active', (el as HTMLElement).dataset.view === view);
    });
    const route = ROUTES.find((r) => r.id === view)!;
    (root.querySelector('#view-title') as HTMLElement).textContent = route.label;
    const container = root.querySelector('#view-container') as HTMLElement;
    container.innerHTML = '<div class="p-10 text-sm text-slate-400">Cargando vista…</div>';
    onView(view, container);
  };

  onRouteChange((v) => setActive(v));
  setActive(currentView());
}

export function setSubtitle(text: string): void {
  const el = document.querySelector('#view-subtitle') as HTMLElement | null;
  if (el) el.textContent = text;
}

export function setFooter(text: string): void {
  const el = document.querySelector('#footer') as HTMLElement | null;
  if (el) el.textContent = text;
}

export function setStamp(text: string): void {
  const el = document.querySelector('#data-stamp') as HTMLElement | null;
  if (el) el.textContent = text;
}
